import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "./AuthShell";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) { setError(formatApiError(e2.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <AuthShell title="Reset Password" subtitle="We'll email you a reset link">
      {sent ? (
        <div className="bg-emerald-50 text-emerald-700 p-4 rounded-lg" data-testid="forgot-confirmation">
          If that email is registered, a reset link has been sent. Check your inbox.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {error && <div className="bg-red-50 text-red-600 text-sm p-3 rounded-lg">{error}</div>}
          <div>
            <label className="text-sm font-semibold text-slate-700">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email"
              className="mt-1 w-full border border-slate-300 rounded-lg px-4 py-3 focus:border-[#22d3ee] outline-none" />
          </div>
          <button disabled={busy} data-testid="forgot-submit"
            className="w-full bg-[#0a1420] text-white font-bold py-3 rounded-lg hover:bg-[#22d3ee] hover:text-[#0a1420] transition-colors disabled:opacity-60">
            {busy ? "Sending…" : "Send Reset Link"}
          </button>
        </form>
      )}
      <p className="text-center text-sm text-slate-500 mt-6"><Link to="/login" className="text-[#06b6d4] font-semibold hover:underline">Back to sign in</Link></p>
    </AuthShell>
  );
}
